(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["definition-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root = document) {
    const containers = root.querySelectorAll('[data-section-id]');

    // Hide all definition modals initially (ingredient-style)
    const modals = document.querySelectorAll('.definition-popup-modal');
    modals.forEach(function(m) {
      if (!m.style.display) m.style.display = 'none';
    });

    containers.forEach(function(container) {
      const filterButtons = container.querySelectorAll('.definition-filter .tab-button--pill');
      const items = container.querySelectorAll('.multicolumn-list__item');
      const categoryDescriptions = container.querySelectorAll('.category-description');

      const searchInput = container.querySelector('.definition-search__input');
      const noResultsEl = container.querySelector('.definition-no-results');
      const allBtn = container.querySelector('.definition-filter .tab-button--pill[data-filter="all"]');
      const listEl = container.querySelector('.multicolumn-list');

      function normalizeText(str) {
        return (str || '')
          .toString()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
.replace(/[^\w\s]/g, '')

          .trim();
      }

      function setHidden(item, shouldHide) {
        item.classList.toggle('is-hidden', !!shouldHide);
      }

      function isHidden(item) {
        return item.classList.contains('is-hidden');
      }

      function getHaystack(item) {
  return normalizeText(item.dataset.searchEn || '');
}


      function setAllActive() {
        if (!allBtn) return;
        filterButtons.forEach(function(b) { b.classList.remove('is-active'); });
        allBtn.classList.add('is-active');
      }

      function updateLastVisiblePadding() {
        items.forEach(function(item) { item.classList.remove('is-last-visible'); });

        let lastVisible = null;
        items.forEach(function(item) {
          if (!isHidden(item)) lastVisible = item;
        });

        if (lastVisible) lastVisible.classList.add('is-last-visible');
      }

      function updateNoResults(visibleCount) {
        if (!noResultsEl) return;

        if (window.location.pathname.indexOf('/nl') === 0) {
          noResultsEl.textContent = 'Geen resultaten gevonden';
        } else {
          noResultsEl.textContent = 'No results found';
        }

        noResultsEl.hidden = visibleCount !== 0;
      }

      function applySearch() {
        const q = normalizeText(searchInput ? searchInput.value : '');

        if (q) setAllActive();

        let visibleCount = 0;
        items.forEach(function(item) {
          const matches = (!q || getHaystack(item).indexOf(q) !== -1);
          setHidden(item, !matches);
          if (matches) visibleCount += 1;
        });

        updateNoResults(visibleCount);
        updateLastVisiblePadding();

        if (listEl && q) {
          listEl.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }

      function debounce(fn, wait) {
        let t;
        return function() {
          clearTimeout(t);
          const args = arguments;
          t = setTimeout(function() { fn.apply(null, args); }, wait);
        };
      }

      const onSearchInput = debounce(applySearch, 200);

      if (searchInput) {
        searchInput.addEventListener('input', onSearchInput);
        searchInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') e.preventDefault();
        });
      }

      // Filter like ingredient-grid (but with class-based hide)
      filterButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const filter = this.getAttribute('data-filter');

          filterButtons.forEach(function(b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');

          if (searchInput) searchInput.value = '';

          let visibleCount = 0;
          items.forEach(function(item) {
            const cat = item.getAttribute('data-category');
            const matches = (filter === 'all' || cat === filter);
            setHidden(item, !matches);
            if (matches) visibleCount += 1;
          });

          categoryDescriptions.forEach(function(desc) {
            const descCategory = desc.getAttribute('data-category');
            if (filter === 'all' || filter !== descCategory) {
              desc.classList.remove('active');
            } else {
              desc.classList.add('active');
            }
          });

          updateNoResults(items.length);
          updateLastVisiblePadding();

          if (listEl) {
            listEl.scrollTo({ left: 0, behavior: 'smooth' });
          }
        });
      });

      /* ------- Modal helpers (ingredient-style) ------- */
      function showModal(modal) {
        modal.style.display = 'flex';
        modal.offsetHeight;
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }

      function hideModal(modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
        setTimeout(function() { modal.style.display = 'none'; }, 200);
      }

      /* ------- Click handler for triggers ------- */
      container.addEventListener('click', function(e) {
        const trigger = e.target.closest('.definition-popup-trigger');
        if (!trigger) return;

        // Prefer item modal-id (same as ingredient)
        const item = trigger.closest('.multicolumn-list__item');
        const modalId = item ? item.getAttribute('data-modal-id') : trigger.getAttribute('data-modal-id');
        if (!modalId) return;

        const modal = document.getElementById(modalId);
        if (!modal) return;

        e.preventDefault();
        showModal(modal);
      });

      updateLastVisiblePadding();
    });

    /* ------- Global close actions ------- */
    document.addEventListener('click', function(e) {

  const modal = e.target.closest('.definition-popup-modal');
  if (!modal) return;

  if (
    e.target.classList.contains('definition-popup-modal__overlay') ||
    e.target.classList.contains('definition-popup-modal__close') ||
    e.target.closest('.definition-popup-modal__close')
  ) {
    modal.classList.remove('open');
    document.body.style.overflow = '';

    setTimeout(function() {
      modal.style.display = 'none';
    }, 200);
  }
});


    document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    const openModal = document.querySelector('.definition-popup-modal.open');
    if (openModal) {
      openModal.classList.remove('open');
      document.body.style.overflow = '';

      setTimeout(function() {
        openModal.style.display = 'none';
      }, 200);
    }
  }
});

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      this.onHideDropdown = this.closeSelector.bind(this);
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      document.body.removeEventListener('click', this.onHideDropdown);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      document.body.addEventListener('click', this.onHideDropdown);
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (shouldClose) {
        this.hidePanel();
      }
      let eventTarget = event.target;
      if (!eventTarget.closest('.dropdown__open_label')) {
        this.hidePanel();
      }

    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(root = document) {
    const containers = root.querySelectorAll('[data-section-id]');

    containers.forEach(function(container) {
      /* ------- Filter ------- */
      const filterButtons = container.querySelectorAll('.ingredient-filter .tab-button--pill');
      const items = container.querySelectorAll('.multicolumn-list__item');
      const categoryDescriptions = container.querySelectorAll('.category-description');

      filterButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const filter = this.getAttribute('data-filter');
          filterButtons.forEach(function(b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');

          // Filter ingredient items
          items.forEach(function(item) {
            const cat = item.getAttribute('data-category');
            item.style.display = (filter === 'all' || cat === filter) ? '' : 'none';
          });

          // Show/hide category descriptions
          categoryDescriptions.forEach(function(desc) {
            const descCategory = desc.getAttribute('data-category');
            if (filter === 'all' || filter !== descCategory) {
              desc.classList.remove('active');
            } else {
              desc.classList.add('active');
            }
          });
        });
      });

      /* ------- Modal helpers ------- */
      function showModal(modal) {
        modal.style.display = 'flex';
        modal.offsetHeight;
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
      function hideModal(modal) {
        modal.classList.remove('open');
        document.body.style.overflow = '';
        setTimeout(function() { modal.style.display = 'none'; }, 200);
      }

      /* ------- Click handler for triggers ------- */
      container.addEventListener('click', function(e) {
        const trigger = e.target.closest('.ingredient-popup-trigger');
        if (!trigger) return;

        const item = trigger.closest('.multicolumn-list__item');
        if (!item) {
          // CTA button is not inside multicolumn-list__item, get modal ID from trigger directly
          const modalId = trigger.getAttribute('data-modal-id');
          if (!modalId) return;

          const modal = document.getElementById(modalId);
          if (!modal) return;

          e.preventDefault();
          showModal(modal);
          return;
        }

        const modalId = item.getAttribute('data-modal-id');
        if (!modalId) return;

        const modal = document.getElementById(modalId);
        if (!modal) return;

        e.preventDefault();
        showModal(modal);
      });
    });

    /* ------- Global close actions ------- */
    document.addEventListener('click', function(e) {
      if (
        e.target.classList.contains('ingredient-popup-modal__overlay') ||
        e.target.classList.contains('ingredient-popup-modal__close') ||
        e.target.closest('.ingredient-popup-modal__close')
      ) {
        const modal = e.target.closest('.ingredient-popup-modal');
        if (modal) {
          modal.classList.remove('open');
          document.body.style.overflow = '';
          setTimeout(function() { modal.style.display = 'none'; }, 200);
        }
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('.ingredient-popup-modal.open');
        if (openModal) {
          openModal.classList.remove('open');
          document.body.style.overflow = '';
          setTimeout(function() { openModal.style.display = 'none'; }, 200);
        }
      }
    });
  }

  /* Init on load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  /* Init when section reloads in Theme Editor */
  document.addEventListener('shopify:section:load', function(e) {
    init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-sticky-slider"] && !Shopify.designMode) return;
  try {
    


  /* Desktop: fade active slide based on scroll */
  document.addEventListener("scroll", () => {
    document.querySelectorAll('.vertical-sticky-slider__slide').forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const inView =
        rect.top < window.innerHeight * 0.75 &&
        rect.bottom > window.innerHeight * 0.25;
      slide.classList.toggle('is-visible', inView);
    });
  });

  /* Mobile: let browser handle momentum scrolling + use dots */
  (function() {
    const slider = document.querySelector('.vertical-sticky-slider__mobile-list');
    const dots = document.querySelectorAll('.vertical-sticky-slider__dot');

    if (!slider) return;

    // Smooth scrolling (native)
    slider.style.scrollBehavior = 'smooth';

    slider.addEventListener('scroll', updateDots);

    function updateDots() {
      const itemWidth = slider.querySelector('.vertical-sticky-slider__mobile-item').offsetWidth;
      const index = Math.round(slider.scrollLeft / itemWidth);

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    updateDots(); // initialize
  })();
  
  } catch(e) { console.error(e); }
})();
})();
